export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 110,
    slots: {
      default: 'opt',
    },
  },
  {
    title: that.$l('table_label_platformNo') || '渠道编号',
    field: 'platformNo',
    minWidth: 120,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_platformName') || '渠道名称',
    field: 'platformName',
    width: 200,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_regionName') || '所属国家地区',
    field: 'regionName',
    width: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_platformType') || '渠道类型',
    field: 'v_platformType',
    width: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_CompanyName') || '申请公司',
    field: 'ecomCompanyName',
    width: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_custName') || '所属客户',
    field: 'custName',
    width: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_lable_status') || '状态',
    field: 'platformStatus',
    width: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    slots: {
      default: 'status',
    },
  },
  {
    title: that.$l('table_label_warehousePmaCode') || '仓库平台',
    field: 'warehousePmaName',
    width: 170,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_ecomPmaCode') || '电商平台账户',
    field: 'ecomPmaName',
    width: 170,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_shippingMethod') || '发运方式',
    field: 'shippingMethod',
    width: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_warehouseCode') || '仓库代码',
    field: 'warehouseCode',
    width: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_shipNode') || '分销商ID',
    field: 'shipNode',
    width: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_inventoryBalanceRatio') || '仓库库存占比',
    field: 'inventoryBalanceRatio',
    width: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_needAttachForShipment') || '否需要上传附件',
    field: 'v_needAttachForShipment',
    width: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_displayCreate') || '创建人',
    field: 'createByName',
    headerAlign: 'left',
    align: 'left',
    width: 170,
    showHeaderOverflow: true,
    slots: {
      default: 'createBy',
    },
  },

  {
    title: that.$l('table_label_modifyBy') || '修改人',
    field: 'modifyByName',
    headerAlign: 'left',
    align: 'left',
    width: 170,
    showHeaderOverflow: true,
    slots: {
      default: 'modifyBy',
    },
  },
]
